<div class="paginate">
    <div class="container large">
        <div class="pagination">
            <ul>
                <li>
                    <a href="javascript:void(0)" v-if="paginate_current.hasPreviousPage" @click="setPage(parseInt(paginate_current.page) - 1)"></a>
                    <a :href="linkPrevPage" v-else></a>
                </li>
                <li v-for="page in paginate_current.pageCount" :key="page" :class="{'active' : parseInt(paginate_current.page) === page}">
                    <a v-if="parseInt(paginate_current.pageCount) <= 5
                    || (parseInt(paginate_current.pageCount) > 5 && ([parseInt(paginate_current.page) - 1, parseInt(paginate_current.page), parseInt(paginate_current.page) + 1].includes(parseInt(page))))
                    || (parseInt(paginate_current.pageCount) > 5 && ([1,2, parseInt(paginate_current.pageCount) - 1, parseInt(paginate_current.pageCount)].includes(parseInt(page))))"
                       href="javascript:void(0)" @click="setPage(page)" style="margin: 0 5px">{{ page }}</a>
                    <span v-else-if="((parseInt(page) === (parseInt(paginate_current.pageCount) - 2) && parseInt(paginate_current.page) < parseInt(paginate_current.pageCount) / 2) || (parseInt(page) === 3 && parseInt(paginate_current.page) > parseInt(paginate_current.pageCount) / 2)) && parseInt(paginate_current.pageCount) > 5"><i class="fa fa-ellipsis-h"></i></span>
                </li>
                <li>
                    <a href="javascript:void(0)" v-if="paginate_current.hasNextPage" @click="setPage(parseInt(paginate_current.page) + 1)"></a>
                    <a href="javascript:void(0)" v-else></a>
                </li>
            </ul>
        </div>
    </div>
</div>
